import { render, staticRenderFns } from "./dataDictionaryDetail.vue?vue&type=template&id=0fbccaaa&scoped=true&"
import script from "./dataDictionaryDetail.vue?vue&type=script&lang=js&"
export * from "./dataDictionaryDetail.vue?vue&type=script&lang=js&"
import style0 from "./dataDictionaryDetail.vue?vue&type=style&index=0&id=0fbccaaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbccaaa",
  null
  
)

export default component.exports